<template>
    <div class="flex">
        <VcPopover
            placement="bottom-start"
            trigger="hover"
            popover-width="auto"
        >
            <div
                v-if="widget.WidgetID"
                class="p-4"
            >
                <p class="main-text-color">
                    {{ t('widget.id') + widget.WidgetID }}
                </p>
                <p class="main-text-color">
                    {{ t('template.name') + templateName + ', ' + templateId }}
                </p>
            </div>

            <template #reference>
                <InfoIcon class="text-primary cursor-help" />
            </template>
        </VcPopover>

        <VcPopover
            v-if="permissionsBlocked.length"
            class="mx-1"
            placement="bottom-start"
            trigger="hover"
        >
            <div
                class="p-4"
                v-html="permissionsBlockedIds"
            />

            <template #reference>
                <AlertTriangleIcon class="text-orange-400 cursor-help" />
            </template>
        </VcPopover>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import get from 'lodash/get'
import { AlertTriangle as AlertTriangleIcon, Info as InfoIcon } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { getWidgetTemplate } from '@/composables/globalData/useTemplatesCategoryData'
import { WidgetExtended } from '@/types/dashboard'
import { VcPopover } from '@voicenter-team/voicenter-ui-plus'

const { t } = useI18n()

const props = defineProps<{
    widget: WidgetExtended
}>()

const widgetTemplate = computed(() => getWidgetTemplate(props.widget.TemplateID))
const templateName = computed(() => get(widgetTemplate.value, 'TemplateName', '--'))
const templateId = computed(() => get(widgetTemplate.value, 'TemplateID', '--'))
const permissionsBlocked = computed(() =>
    get(props.widget, 'WidgetLayout.PermissionsBlocked', [])
)

const permissionsBlockedIds = computed(() => {
    const blockedIds = permissionsBlocked.value.join(', ')
    return `${t('general.error.partialListPermissionsIssues')} <br> ${t(
        'general.error.theFollowingIDsWereNotDisplayedAre'
    )}: <b>${blockedIds}</b>`
})
</script>
